module.exports = __webpack_public_path__ + "media/images/athletes/1443-54bffa0ae20a648ccb161dea142d53b0.png";